import { AxiosPromise } from "axios";
import { apiWrapper } from "../../axiosInstance";
import { ApiWfsServiceResponse } from "./types";

export const getFeaturesByParamsEndpoint = (requestParams: string): AxiosPromise<ApiWfsServiceResponse> =>
    apiWrapper.instance!.get(`wfs?${requestParams}`);
